import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';
import Button from '../../../components/ui/Button';
import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';
import LoadingSpinner from '../../../components/LoadingSpinner';
import { eventService } from '../../../services/eventService';
import { storageService } from '../../../services/storageService';
import { useAuth } from '../../../contexts/AuthContext';
import EventRegistrationsModal from './EventRegistrationsModal';
import RichTextEditor from '../../event-creation/components/RichTextEditor';

const TURKISH_CITIES = [
  { value: 'adana', label: 'Adana' },
  { value: 'adiyaman', label: 'Adıyaman' },
  { value: 'afyonkarahisar', label: 'Afyonkarahisar' },
  { value: 'agri', label: 'Ağrı' },
  { value: 'aksaray', label: 'Aksaray' },
  { value: 'amasya', label: 'Amasya' },
  { value: 'ankara', label: 'Ankara' },
  { value: 'antalya', label: 'Antalya' },
  { value: 'ardahan', label: 'Ardahan' },
  { value: 'artvin', label: 'Artvin' },
  { value: 'aydin', label: 'Aydın' },
  { value: 'balikesir', label: 'Balıkesir' },
  { value: 'bartin', label: 'Bartın' },
  { value: 'batman', label: 'Batman' },
  { value: 'bayburt', label: 'Bayburt' },
  { value: 'bilecik', label: 'Bilecik' },
  { value: 'bingol', label: 'Bingöl' },
  { value: 'bitlis', label: 'Bitlis' },
  { value: 'bolu', label: 'Bolu' },
  { value: 'burdur', label: 'Burdur' },
  { value: 'bursa', label: 'Bursa' },
  { value: 'canakkale', label: 'Çanakkale' },
  { value: 'cankiri', label: 'Çankırı' },
  { value: 'corum', label: 'Çorum' },
  { value: 'denizli', label: 'Denizli' },
  { value: 'diyarbakir', label: 'Diyarbakır' },
  { value: 'duzce', label: 'Düzce' },
  { value: 'edirne', label: 'Edirne' },
  { value: 'elazig', label: 'Elazığ' },
  { value: 'erzincan', label: 'Erzincan' },
  { value: 'erzurum', label: 'Erzurum' },
  { value: 'eskisehir', label: 'Eskişehir' },
  { value: 'gaziantep', label: 'Gaziantep' },
  { value: 'giresun', label: 'Giresun' },
  { value: 'gumushane', label: 'Gümüşhane' },
  { value: 'hakkari', label: 'Hakkari' },
  { value: 'hatay', label: 'Hatay' },
  { value: 'igdir', label: 'Iğdır' },
  { value: 'isparta', label: 'Isparta' },
  { value: 'istanbul', label: 'İstanbul' },
  { value: 'izmir', label: 'İzmir' },
  { value: 'kahramanmaras', label: 'Kahramanmaraş' },
  { value: 'karabuk', label: 'Karabük' },
  { value: 'karaman', label: 'Karaman' },
  { value: 'kars', label: 'Kars' },
  { value: 'kastamonu', label: 'Kastamonu' },
  { value: 'kayseri', label: 'Kayseri' },
  { value: 'kilis', label: 'Kilis' },
  { value: 'kirikkale', label: 'Kırıkkale' },
  { value: 'kirklareli', label: 'Kırklareli' },
  { value: 'kirsehir', label: 'Kırşehir' },
  { value: 'kocaeli', label: 'Kocaeli' },
  { value: 'konya', label: 'Konya' },
  { value: 'kutahya', label: 'Kütahya' },
  { value: 'malatya', label: 'Malatya' },
  { value: 'manisa', label: 'Manisa' },
  { value: 'mardin', label: 'Mardin' },
  { value: 'mersin', label: 'Mersin' },
  { value: 'mugla', label: 'Muğla' },
  { value: 'mus', label: 'Muş' },
  { value: 'nevsehir', label: 'Nevşehir' },
  { value: 'nigde', label: 'Niğde' },
  { value: 'ordu', label: 'Ordu' },
  { value: 'osmaniye', label: 'Osmaniye' },
  { value: 'rize', label: 'Rize' },
  { value: 'sakarya', label: 'Sakarya' },
  { value: 'samsun', label: 'Samsun' },
  { value: 'sanliurfa', label: 'Şanlıurfa' },
  { value: 'siirt', label: 'Siirt' },
  { value: 'sinop', label: 'Sinop' },
  { value: 'sirnak', label: 'Şırnak' },
  { value: 'sivas', label: 'Sivas' },
  { value: 'tekirdag', label: 'Tekirdağ' },
  { value: 'tokat', label: 'Tokat' },
  { value: 'trabzon', label: 'Trabzon' },
  { value: 'tunceli', label: 'Tunceli' },
  { value: 'usak', label: 'Uşak' },
  { value: 'van', label: 'Van' },
  { value: 'yalova', label: 'Yalova' },
  { value: 'yozgat', label: 'Yozgat' },
  { value: 'zonguldak', label: 'Zonguldak' },
];

const DIFFICULTY_OPTIONS = [
  { value: 'beginner', label: 'Başlangıç' },
  { value: 'intermediate', label: 'Orta' },
  { value: 'advanced', label: 'İleri' },
  { value: 'expert', label: 'Uzman' },
];

const DetailedEventManagement = () => {
  const navigate = useNavigate();
  const { user } = useAuth();
  const [searchTerm, setSearchTerm] = useState('');
  const [statusFilter, setStatusFilter] = useState('all');
  const [sortBy, setSortBy] = useState('created');
  const [events, setEvents] = useState([]);
  const [selectedEvent, setSelectedEvent] = useState(null);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [eventToDelete, setEventToDelete] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const [showRegistrationsModal, setShowRegistrationsModal] = useState(false);
  const [selectedEventForRegistrations, setSelectedEventForRegistrations] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [imageUploadMode, setImageUploadMode] = useState('url'); // 'url' or 'file'
  const [imageFile, setImageFile] = useState(null);
  const [imagePreview, setImagePreview] = useState('');
  const [isUploadingImage, setIsUploadingImage] = useState(false);
  const fileInputRef = useRef(null);
  const [formData, setFormData] = useState({
    title: '',
    description: '',
    date: '',
    time: '',
    location: '',
    latitude: '',
    longitude: '',
    city: 'istanbul',
    difficulty: 'beginner',
    priceOwnBoard: 0,
    priceWithRental: 0,
    maxParticipants: 0,
    minParticipants: 1,
    eventType: 'sup',
    image: '',
    priceLifeVest: 0,
    priceSupMotor: 0,
    priceWaterproofBag: 0,
    duration: '',
    status: 'published',
    customOptions: [],
    customOptionsType: 'multiple',
    allowOwnBoard: true,
    allowRentalBoard: true,
    allowStandardTicket: false,
    priceStandardTicket: 0,
    descOwnBoard: '',
    descRentalBoard: '',
    descStandardTicket: ''
  });
  // Multi-photo state
  const [photoList, setPhotoList] = useState([]); // [{type:'url'|'file', url:'...', file: File|null, preview:'...'}]
  const [newPhotoUrl, setNewPhotoUrl] = useState('');
  const multiFileInputRef = useRef(null);

  // Effect to populate form when editing
  useEffect(() => {
    if (selectedEvent && isModalOpen) {
      const existingImage = selectedEvent?.image || (selectedEvent?.images && selectedEvent?.images?.[0]) || '';
      // Build photo list from existing images
      const existingImages = selectedEvent?.images && selectedEvent?.images?.length > 0
        ? selectedEvent?.images
        : existingImage ? [existingImage] : [];
      setPhotoList(existingImages?.map(url => ({ type: 'url', url, file: null, preview: url })));
      setFormData({
        title: selectedEvent?.title || '',
        description: selectedEvent?.description || '',
        date: selectedEvent?.date || '',
        time: selectedEvent?.time || '',
        location: selectedEvent?.location || '',
        latitude: selectedEvent?.latitude || '',
        longitude: selectedEvent?.longitude || '',
        city: selectedEvent?.city || 'istanbul',
        difficulty: selectedEvent?.difficulty || 'beginner',
        priceOwnBoard: selectedEvent?.priceOwnBoard || 0,
        priceWithRental: selectedEvent?.priceWithRental || 0,
        priceLifeVest: selectedEvent?.priceLifeVest || 0,
        priceSupMotor: selectedEvent?.priceSupMotor || 0,
        priceWaterproofBag: selectedEvent?.priceWaterproofBag || 0,
        maxParticipants: selectedEvent?.maxParticipants || 0,
        minParticipants: selectedEvent?.minParticipants || 1,
        eventType: selectedEvent?.eventType || 'sup',
        image: existingImage,
        duration: selectedEvent?.duration || '',
        status: selectedEvent?.status || 'published',
        customOptions: Array.isArray(selectedEvent?.custom_options) ? selectedEvent?.custom_options : [],
        customOptionsType: selectedEvent?.customOptionsType || selectedEvent?.custom_options_type || 'multiple',
        allowOwnBoard: selectedEvent?.allowOwnBoard !== false,
        allowRentalBoard: selectedEvent?.allowRentalBoard !== false,
        allowStandardTicket: selectedEvent?.allowStandardTicket === true,
        priceStandardTicket: selectedEvent?.priceStandardTicket || 0,
        descOwnBoard: selectedEvent?.descOwnBoard || '',
        descRentalBoard: selectedEvent?.descRentalBoard || '',
        descStandardTicket: selectedEvent?.descStandardTicket || ''
      });
      setImagePreview(existingImage);
      setImageFile(null);
      setImageUploadMode('url');
      setNewPhotoUrl('');
    } else if (!isModalOpen) {
      setPhotoList([]);
      setNewPhotoUrl('');
      setFormData({
        title: '',
        description: '',
        date: '',
        time: '',
        location: '',
        latitude: '',
        longitude: '',
        city: 'istanbul',
        difficulty: 'beginner',
        priceOwnBoard: 0,
        priceWithRental: 0,
        maxParticipants: 0,
        minParticipants: 1,
        eventType: 'sup',
        image: '',
        priceLifeVest: 0,
        priceSupMotor: 0,
        priceWaterproofBag: 0,
        duration: '',
        status: 'published',
        customOptions: [],
        customOptionsType: 'multiple',
        allowOwnBoard: true,
        allowRentalBoard: true,
        allowStandardTicket: false,
        priceStandardTicket: 0,
        descOwnBoard: '',
        descRentalBoard: '',
        descStandardTicket: ''
      });
      setImagePreview('');
      setImageFile(null);
      setImageUploadMode('url');
    }
  }, [selectedEvent, isModalOpen]);

  useEffect(() => {
    loadEvents();
  }, []);

  const loadEvents = async () => {
    try {
      setIsLoading(true);
      setError(null);
      const data = await eventService?.getAllForAdmin();
      setEvents(data || []);
    } catch (err) {
      console.error('Error loading events:', err);
      setError(err?.message || 'Etkinlikler yüklenirken bir hata oluştu');
    } finally {
      setIsLoading(false);
    }
  };

  const statusOptions = [
    { value: 'all', label: 'Tüm Durumlar' },
    { value: 'published', label: 'Yayında' },
    { value: 'draft', label: 'Taslak' },
    { value: 'completed', label: 'Tamamlandı' },
    { value: 'cancelled', label: 'İptal Edildi' }
  ];

  const sortOptions = [
    { value: 'date', label: 'Tarihe Göre' },
    { value: 'title', label: 'İsme Göre' },
    { value: 'attendees', label: 'Katılımcı Sayısı' },
    { value: 'created', label: 'Oluşturma Tarihi' }
  ];

  const filteredEvents = events?.filter(event => {
    const matchesSearch = event?.title?.toLowerCase()?.includes(searchTerm?.toLowerCase()) ||
                         event?.organizerName?.toLowerCase()?.includes(searchTerm?.toLowerCase()) ||
                         event?.location?.toLowerCase()?.includes(searchTerm?.toLowerCase());
    const matchesStatus = statusFilter === 'all' || event?.status === statusFilter;
    return matchesSearch && matchesStatus;
  });

  const sortedEvents = [...filteredEvents]?.sort((a, b) => {
    switch (sortBy) {
      case 'title':
        return a?.title?.localeCompare(b?.title);
      case 'attendees':
        return (b?.attendeeCount || 0) - (a?.attendeeCount || 0);
      case 'date':
        return new Date(b?.date) - new Date(a?.date);
      case 'created':
      default:
        return new Date(b?.createdAt) - new Date(a?.createdAt);
    }
  });

  const handleCreateEvent = () => {
    navigate('/event-creation');
  };

  const handleEditEvent = (event) => {
    setSelectedEvent(event);
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setSelectedEvent(null);
  };

  const handleFormChange = (field, value) => {
    setFormData(prev => ({
      ...prev,
      [field]: value
    }));
    if (field === 'image') {
      setImagePreview(value);
    }
  };

  const handleFileSelect = (e) => {
    const file = e?.target?.files?.[0];
    if (!file) return;
    setImageFile(file);
    const previewUrl = URL.createObjectURL(file);
    setImagePreview(previewUrl);
  };

  // Multi-photo handlers
  const handleAddPhotoUrl = () => {
    const trimmed = newPhotoUrl?.trim();
    if (!trimmed) return;
    setPhotoList(prev => [...prev, { type: 'url', url: trimmed, file: null, preview: trimmed }]);
    setNewPhotoUrl('');
  };

  const handleMultiFileSelect = (e) => {
    const files = Array.from(e?.target?.files || []);
    if (!files?.length) return;
    const newPhotos = files?.map(file => ({
      type: 'file',
      url: '',
      file,
      preview: URL.createObjectURL(file)
    }));
    setPhotoList(prev => [...prev, ...newPhotos]);
    e.target.value = '';
  };

  const handleRemovePhoto = (index) => {
    setPhotoList(prev => prev?.filter((_, i) => i !== index));
  };

  const handleSaveEvent = async () => {
    try {
      setIsLoading(true);
      setIsUploadingImage(true);

      // Upload any file-type photos and collect all URLs
      const uploadedUrls = await Promise.all(
        photoList?.map(async (photo) => {
          if (photo?.type === 'file' && photo?.file) {
            const userId = user?.id || 'admin';
            return await storageService?.uploadEventImage(photo?.file, userId);
          }
          return photo?.url;
        })
      );

      const validUrls = uploadedUrls?.filter(Boolean);
      const finalImageUrl = validUrls?.[0] || '';

      setIsUploadingImage(false);

      if (selectedEvent) {
        const submissionData = {
          ...formData,
          image: finalImageUrl,
          images: validUrls,
          status: formData?.status || 'published',
          customOptions: formData?.customOptions || [],
          customOptionsType: formData?.customOptionsType || 'multiple'
        };
        await eventService?.update(selectedEvent?.id, submissionData);
      }
      await loadEvents();
      handleCloseModal();
    } catch (err) {
      console.error('Error saving event:', err);
      setIsUploadingImage(false);
      setError(err?.message || 'Etkinlik kaydedilirken bir hata oluştu');
    } finally {
      setIsLoading(false);
    }
  };

  const handleDeleteEvent = (event) => {
    setEventToDelete(event);
    setShowDeleteModal(true);
  };

  const confirmDelete = async () => {
    try {
      await eventService?.delete(eventToDelete?.id);
      await loadEvents(); // Reload events after deletion
      setShowDeleteModal(false);
      setEventToDelete(null);
    } catch (err) {
      console.error('Error deleting event:', err);
      setError(err?.message || 'Etkinlik silinirken bir hata oluştu');
    }
  };

  const handleViewDetails = (event) => {
    setSelectedEvent(event);
  };

  const handleStatusChange = async (eventId, newStatus) => {
    try {
      await eventService?.updateStatus(eventId, newStatus);
      await loadEvents(); // Reload events after status change
    } catch (err) {
      console.error('Error updating event status:', err);
      setError(err?.message || 'Durum güncellenirken bir hata oluştu');
    }
  };

  const handleViewRegistrations = (event) => {
    setSelectedEventForRegistrations(event);
    setShowRegistrationsModal(true);
  };

  const getStatusBadge = (status) => {
    const statusConfig = {
      published: { label: 'Yayında', color: 'bg-success/10 text-success' },
      draft: { label: 'Taslak', color: 'bg-muted/50 text-muted-foreground' },
      completed: { label: 'Tamamlandı', color: 'bg-primary/10 text-primary' },
      cancelled: { label: 'İptal Edildi', color: 'bg-error/10 text-error' }
    };
    const config = statusConfig?.[status] || statusConfig?.published;
    return (
      <span className={`inline-flex items-center gap-1 px-3 py-1 rounded-md text-xs font-medium ${config?.color}`}>
        {config?.label}
      </span>
    );
  };

  const formatDate = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    return date?.toLocaleDateString('tr-TR', { 
      year: 'numeric', 
      month: 'long', 
      day: 'numeric' 
    });
  };

  const formatTime = (timeString) => {
    if (!timeString) return '';
    return timeString?.substring(0, 5); // Extract HH:MM from HH:MM:SS
  };

  if (isLoading) {
    return (
      <div className="flex items-center justify-center py-12">
        <LoadingSpinner />
      </div>
    );
  }

  if (error) {
    return (
      <div className="bg-error/10 border border-error/20 rounded-lg p-4 text-error">
        <p className="font-medium mb-2">Hata</p>
        <p className="text-sm">{error}</p>
        <Button
          variant="outline"
          size="sm"
          onClick={loadEvents}
          className="mt-4"
        >
          Tekrar Dene
        </Button>
      </div>
    );
  }

  return (
    <div className="space-y-6">
      {/* Header Section */}
      <div className="bg-gradient-to-r from-primary to-secondary p-6 rounded-xl text-white">
        <div className="flex flex-col md:flex-row md:items-center justify-between gap-4">
          <div>
            <h2 className="text-2xl md:text-3xl font-bold mb-2">Etkinlik Yönetimi</h2>
            <p className="text-white/90">Tüm etkinlikleri oluşturun, düzenleyin ve yönetin</p>
          </div>
          <Button
            variant="default"
            size="lg"
            iconName="Plus"
            iconPosition="left"
            onClick={handleCreateEvent}
            className="bg-white text-primary hover:bg-white/90 shadow-lg"
          >
            Yeni Etkinlik Oluştur
          </Button>
        </div>
      </div>
      {/* Stats Cards */}
      <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
        <div className="bg-card border border-border rounded-lg p-4">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm text-muted-foreground mb-1">Toplam Etkinlik</p>
              <p className="text-2xl font-bold text-foreground">{events?.length}</p>
            </div>
            <div className="w-12 h-12 rounded-full bg-primary/10 flex items-center justify-center">
              <Icon name="Calendar" size={24} className="text-primary" />
            </div>
          </div>
        </div>
        <div className="bg-card border border-border rounded-lg p-4">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm text-muted-foreground mb-1">Yayında</p>
              <p className="text-2xl font-bold text-foreground">
                {events?.filter(e => e?.status === 'published')?.length}
              </p>
            </div>
            <div className="w-12 h-12 rounded-full bg-success/10 flex items-center justify-center">
              <Icon name="CheckCircle" size={24} className="text-success" />
            </div>
          </div>
        </div>
        <div className="bg-card border border-border rounded-lg p-4">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm text-muted-foreground mb-1">Toplam Katılımcı</p>
              <p className="text-2xl font-bold text-foreground">
                {events?.reduce((sum, e) => sum + (e?.attendeeCount || 0), 0)}
              </p>
            </div>
            <div className="w-12 h-12 rounded-full bg-secondary/10 flex items-center justify-center">
              <Icon name="Users" size={24} className="text-secondary" />
            </div>
          </div>
        </div>
        <div className="bg-card border border-border rounded-lg p-4">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm text-muted-foreground mb-1">Tamamlanan</p>
              <p className="text-2xl font-bold text-foreground">
                {events?.filter(e => e?.status === 'completed')?.length}
              </p>
            </div>
            <div className="w-12 h-12 rounded-full bg-primary/10 flex items-center justify-center">
              <Icon name="Award" size={24} className="text-primary" />
            </div>
          </div>
        </div>
      </div>
      {/* Filters and Search */}
      <div className="bg-card rounded-xl border border-border p-4 md:p-6">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          <Input
            type="search"
            placeholder="Etkinlik, organizatör veya konum ara..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e?.target?.value)}
          />
          <Select
            options={statusOptions}
            value={statusFilter}
            onChange={setStatusFilter}
            placeholder="Durum filtrele"
          />
          <Select
            options={sortOptions}
            value={sortBy}
            onChange={setSortBy}
            placeholder="Sırala"
          />
        </div>
      </div>
      {/* Events List */}
      <div className="bg-card rounded-xl border border-border">
        <div className="divide-y divide-border">
          {sortedEvents?.length > 0 ? (
            sortedEvents?.map((event) => (
              <div key={event?.id} className="p-4 md:p-6 hover:bg-muted/30 transition-smooth">
                <div className="flex flex-col lg:flex-row gap-4">
                  <Image
                    src={event?.image}
                    alt={event?.imageAlt}
                    className="w-full lg:w-40 h-40 rounded-lg object-cover flex-shrink-0"
                  />
                  
                  <div className="flex-1 min-w-0">
                    <div className="flex flex-col sm:flex-row sm:items-start justify-between gap-3 mb-3">
                      <div className="flex-1 min-w-0">
                        <h3 className="text-lg font-semibold text-foreground mb-1">{event?.title}</h3>
                        <p className="text-sm text-muted-foreground mb-2">Organizatör: {event?.organizerName}</p>
                        <div className="flex flex-wrap items-center gap-3 text-sm text-muted-foreground">
                          <span className="flex items-center gap-1">
                            <Icon name="Calendar" size={14} />
                            {formatDate(event?.date)}
                          </span>
                          <span className="flex items-center gap-1">
                            <Icon name="Clock" size={14} />
                            {formatTime(event?.time)}
                          </span>
                          <span className="flex items-center gap-1">
                            <Icon name="MapPin" size={14} />
                            {event?.location}
                          </span>
                          <span className="flex items-center gap-1">
                            <Icon name="Users" size={14} />
                            {event?.attendeeCount || 0} / {event?.maxParticipants} katılımcı
                          </span>
                        </div>
                      </div>
                      {getStatusBadge(event?.status)}
                    </div>

                    <div className="flex flex-wrap gap-2">
                      <Button
                        variant="default"
                        size="sm"
                        iconName="Edit"
                        iconPosition="left"
                        onClick={() => handleEditEvent(event)}
                      >
                        Düzenle
                      </Button>
                      <Button
                        variant="outline"
                        size="sm"
                        iconName="Eye"
                        iconPosition="left"
                        onClick={() => handleViewDetails(event)}
                      >
                        Detaylar
                      </Button>
                      <Button
                        variant="secondary"
                        size="sm"
                        iconName="Users"
                        iconPosition="left"
                        onClick={() => handleViewRegistrations(event)}
                      >
                        Rezervasyonlar
                      </Button>
                      <Select
                        options={statusOptions?.filter(opt => opt?.value !== 'all')}
                        value={event?.status}
                        onChange={(value) => handleStatusChange(event?.id, value)}
                        placeholder="Durum Değiştir"
                      />
                      <Button
                        variant="ghost"
                        size="sm"
                        iconName="Trash2"
                        iconPosition="left"
                        onClick={() => handleDeleteEvent(event)}
                        className="text-error hover:text-error"
                      >
                        Sil
                      </Button>
                    </div>
                  </div>
                </div>
              </div>
            ))
          ) : (
            <div className="p-12 text-center">
              <Icon name="Calendar" size={48} className="mx-auto mb-4 text-muted-foreground opacity-50" />
              <p className="text-muted-foreground mb-4">Henüz etkinlik bulunmuyor</p>
              <Button
                variant="default"
                iconName="Plus"
                iconPosition="left"
                onClick={handleCreateEvent}
              >
                İlk Etkinliği Oluştur
              </Button>
            </div>
          )}
        </div>
      </div>
      {/* Delete Confirmation Modal */}
      {showDeleteModal && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
          <div className="bg-card rounded-xl max-w-md w-full p-6">
            <div className="flex items-center gap-3 mb-4">
              <div className="w-12 h-12 rounded-full bg-error/10 flex items-center justify-center">
                <Icon name="AlertTriangle" size={24} className="text-error" />
              </div>
              <h3 className="text-xl font-semibold text-foreground">Etkinliği Sil</h3>
            </div>
            <p className="text-muted-foreground mb-6">
              <strong>{eventToDelete?.title}</strong> etkinliğini silmek istediğinizden emin misiniz? Bu işlem geri alınamaz.
            </p>
            <div className="flex gap-3">
              <Button
                variant="outline"
                onClick={() => setShowDeleteModal(false)}
                className="flex-1"
              >
                İptal
              </Button>
              <Button
                variant="danger"
                onClick={confirmDelete}
                className="flex-1"
              >
                Sil
              </Button>
            </div>
          </div>
        </div>
      )}
      {/* Event Details Modal */}
      {selectedEvent && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4 overflow-y-auto">
          <div className="bg-card rounded-xl max-w-3xl w-full p-6 my-8">
            <div className="flex items-center justify-between mb-6">
              <h3 className="text-2xl font-semibold text-foreground">Etkinlik Detayları</h3>
              <button
                onClick={() => setSelectedEvent(null)}
                className="w-8 h-8 rounded-full hover:bg-muted flex items-center justify-center transition-smooth"
              >
                <Icon name="X" size={20} />
              </button>
            </div>
            <div className="space-y-4">
              <Image
                src={selectedEvent?.image}
                alt={selectedEvent?.imageAlt}
                className="w-full h-64 rounded-lg object-cover"
              />
              <div>
                <h4 className="text-xl font-semibold text-foreground mb-2">{selectedEvent?.title}</h4>
                <p className="text-muted-foreground mb-4">{selectedEvent?.description}</p>
              </div>
              <div className="grid grid-cols-2 gap-4">
                <div>
                  <p className="text-sm text-muted-foreground mb-1">Tarih</p>
                  <p className="text-foreground font-medium">{formatDate(selectedEvent?.date)}</p>
                </div>
                <div>
                  <p className="text-sm text-muted-foreground mb-1">Saat</p>
                  <p className="text-foreground font-medium">{formatTime(selectedEvent?.time)}</p>
                </div>
                <div>
                  <p className="text-sm text-muted-foreground mb-1">Konum</p>
                  <p className="text-foreground font-medium">{selectedEvent?.location}</p>
                </div>
                <div>
                  <p className="text-sm text-muted-foreground mb-1">Zorluk</p>
                  <p className="text-foreground font-medium">{selectedEvent?.difficulty}</p>
                </div>
                <div>
                  <p className="text-sm text-muted-foreground mb-1">Katılımcı</p>
                  <p className="text-foreground font-medium">
                    {selectedEvent?.attendeeCount || 0} / {selectedEvent?.maxParticipants}
                  </p>
                </div>
                <div>
                  <p className="text-sm text-muted-foreground mb-1">Fiyat</p>
                  <p className="text-foreground font-medium">₺{selectedEvent?.priceOwnBoard}</p>
                </div>
              </div>
              <Button
                variant="outline"
                onClick={() => setSelectedEvent(null)}
                className="w-full"
              >
                Kapat
              </Button>
            </div>
          </div>
        </div>
      )}
      {/* Registrations Modal */}
      {showRegistrationsModal && selectedEventForRegistrations && (
        <EventRegistrationsModal
          event={selectedEventForRegistrations}
          onClose={() => {
            setShowRegistrationsModal(false);
            setSelectedEventForRegistrations(null);
            loadEvents(); // Reload events to update attendee counts
          }}
        />
      )}
      {/* Edit Event Modal */}
      {isModalOpen && selectedEvent && (
        <div className="fixed inset-0 bg-black/50 flex items-start justify-center z-50 p-4 overflow-y-auto">
          <div className="bg-card rounded-xl max-w-2xl w-full p-6 my-4">
            <div className="flex items-center justify-between mb-6">
              <h3 className="text-2xl font-semibold text-foreground">Etkinliği Düzenle</h3>
              <button
                onClick={handleCloseModal}
                className="w-8 h-8 rounded-full hover:bg-muted flex items-center justify-center transition-smooth"
              >
                <Icon name="X" size={20} />
              </button>
            </div>
            <div className="space-y-4">
              <div>
                <label className="block text-sm font-medium text-foreground mb-2">Başlık</label>
                <Input
                  type="text"
                  value={formData?.title}
                  onChange={(e) => handleFormChange('title', e?.target?.value)}
                  placeholder="Etkinlik başlığı"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-foreground mb-2">Açıklama</label>
                <RichTextEditor
                  value={formData?.description}
                  onChange={(value) => handleFormChange('description', value)}
                  error={null}
                  compact={true}
                />
              </div>
              <div className="grid grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm font-medium text-foreground mb-2">Tarih</label>
                  <Input
                    type="date"
                    value={formData?.date}
                    onChange={(e) => handleFormChange('date', e?.target?.value)}
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-foreground mb-2">Saat</label>
                  <Input
                    type="time"
                    value={formData?.time}
                    onChange={(e) => handleFormChange('time', e?.target?.value)}
                  />
                </div>
              </div>
              <div>
                <label className="block text-sm font-medium text-foreground mb-2">Konum</label>
                <Input
                  type="text"
                  value={formData?.location}
                  onChange={(e) => handleFormChange('location', e?.target?.value)}
                  placeholder="Etkinlik konumu (Örn: Aya Yorgi Koyu, Caddebostan)"
                />
              </div>
              <div className="grid grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm font-medium text-muted-foreground mb-2">Enlem (Latitude) - Opsiyonel</label>
                  <Input
                    type="text"
                    value={formData?.latitude}
                    onChange={(e) => handleFormChange('latitude', e?.target?.value)}
                    placeholder="Örn: 41.0082"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-muted-foreground mb-2">Boylam (Longitude) - Opsiyonel</label>
                  <Input
                    type="text"
                    value={formData?.longitude}
                    onChange={(e) => handleFormChange('longitude', e?.target?.value)}
                    placeholder="Örn: 28.9784"
                  />
                </div>
              </div>
              <div className="grid grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm font-medium text-foreground mb-2">Şehir</label>
                  <select
                    value={formData?.city}
                    onChange={(e) => handleFormChange('city', e?.target?.value)}
                    className="w-full h-10 px-3 py-2 border border-input bg-white text-black rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-primary"
                  >
                    {TURKISH_CITIES?.map(city => (
                      <option key={city?.value} value={city?.value}>{city?.label}</option>
                    ))}
                  </select>
                </div>
                <div>
                  <label className="block text-sm font-medium text-foreground mb-2">Zorluk Seviyesi</label>
                  <select
                    value={formData?.difficulty}
                    onChange={(e) => handleFormChange('difficulty', e?.target?.value)}
                    className="w-full h-10 px-3 py-2 border border-input bg-white text-black rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-primary"
                  >
                    {DIFFICULTY_OPTIONS?.map(opt => (
                      <option key={opt?.value} value={opt?.value}>{opt?.label}</option>
                    ))}
                  </select>
                </div>
              </div>
              {/* Katılım & Bilet Seçenekleri */}
              <div className="border border-border rounded-xl p-4 bg-muted/20">
                <h4 className="text-sm font-semibold text-foreground mb-1 flex items-center gap-2">
                  <Icon name="Ticket" size={16} className="text-primary" />
                  Katılım &amp; Bilet Seçenekleri
                </h4>
                <p className="text-xs text-muted-foreground mb-4">Etkinlikte sunulacak bilet türlerini, fiyatlarını ve açıklamalarını düzenleyin.</p>
                <div className="space-y-3">
                  {/* Own Board */}
                  <div className={`rounded-lg border-2 p-3 transition-colors ${formData?.allowOwnBoard !== false ? 'border-primary/40 bg-primary/5' : 'border-border bg-background'}`}>
                    <div className="flex items-center gap-3 mb-2">
                      <input type="checkbox" id="edit_allowOwnBoard" checked={formData?.allowOwnBoard !== false} onChange={(e) => handleFormChange('allowOwnBoard', e?.target?.checked)} className="w-4 h-4 text-primary border-border rounded focus:ring-primary cursor-pointer" />
                      <label htmlFor="edit_allowOwnBoard" className="text-sm font-semibold text-foreground cursor-pointer">Kendi Board'u İle Katılım</label>
                    </div>
                    {formData?.allowOwnBoard !== false && (
                      <div className="ml-7 grid grid-cols-2 gap-3">
                        <div>
                          <label className="block text-xs font-medium text-foreground mb-1">Fiyat (₺)</label>
                          <Input type="number" value={formData?.priceOwnBoard || 0} onChange={(e) => handleFormChange('priceOwnBoard', parseFloat(e?.target?.value) || 0)} min="0" step="10" />
                        </div>
                        <div>
                          <label className="block text-xs font-medium text-foreground mb-1">Açıklama / Alt Metin</label>
                          <input type="text" value={formData?.descOwnBoard || ''} onChange={(e) => handleFormChange('descOwnBoard', e?.target?.value)} placeholder="Örn: Kendi SUP board'unuzu getirin" className="w-full h-9 px-3 py-2 border border-input bg-background text-foreground rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-primary placeholder:text-muted-foreground" />
                        </div>
                      </div>
                    )}
                  </div>
                  {/* Rental Board */}
                  <div className={`rounded-lg border-2 p-3 transition-colors ${formData?.allowRentalBoard !== false ? 'border-secondary/40 bg-secondary/5' : 'border-border bg-background'}`}>
                    <div className="flex items-center gap-3 mb-2">
                      <input type="checkbox" id="edit_allowRentalBoard" checked={formData?.allowRentalBoard !== false} onChange={(e) => handleFormChange('allowRentalBoard', e?.target?.checked)} className="w-4 h-4 text-primary border-border rounded focus:ring-primary cursor-pointer" />
                      <label htmlFor="edit_allowRentalBoard" className="text-sm font-semibold text-foreground cursor-pointer">Board Kiralama Dahil Katılım</label>
                    </div>
                    {formData?.allowRentalBoard !== false && (
                      <div className="ml-7 grid grid-cols-2 gap-3">
                        <div>
                          <label className="block text-xs font-medium text-foreground mb-1">Fiyat (₺)</label>
                          <Input type="number" value={formData?.priceWithRental || 0} onChange={(e) => handleFormChange('priceWithRental', parseFloat(e?.target?.value) || 0)} min="0" step="10" />
                        </div>
                        <div>
                          <label className="block text-xs font-medium text-foreground mb-1">Açıklama / Alt Metin</label>
                          <input type="text" value={formData?.descRentalBoard || ''} onChange={(e) => handleFormChange('descRentalBoard', e?.target?.value)} placeholder="Örn: Ekipman kiralama dahil, sadece gelin" className="w-full h-9 px-3 py-2 border border-input bg-background text-foreground rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-primary placeholder:text-muted-foreground" />
                        </div>
                      </div>
                    )}
                  </div>
                  {/* Standard Ticket */}
                  <div className={`rounded-lg border-2 p-3 transition-colors ${formData?.allowStandardTicket === true ? 'border-amber-400/60 bg-amber-50/50' : 'border-border bg-background'}`}>
                    <div className="flex items-center gap-3 mb-2">
                      <input type="checkbox" id="edit_allowStandardTicket" checked={formData?.allowStandardTicket === true} onChange={(e) => handleFormChange('allowStandardTicket', e?.target?.checked)} className="w-4 h-4 text-primary border-border rounded focus:ring-primary cursor-pointer" />
                      <label htmlFor="edit_allowStandardTicket" className="text-sm font-semibold text-foreground cursor-pointer">Standart Etkinlik Bileti / Board Yok</label>
                    </div>
                    {formData?.allowStandardTicket === true && (
                      <div className="ml-7 grid grid-cols-2 gap-3">
                        <div>
                          <label className="block text-xs font-medium text-foreground mb-1">Fiyat (₺)</label>
                          <Input type="number" value={formData?.priceStandardTicket || 0} onChange={(e) => handleFormChange('priceStandardTicket', parseFloat(e?.target?.value) || 0)} min="0" step="10" />
                        </div>
                        <div>
                          <label className="block text-xs font-medium text-foreground mb-1">Açıklama / Alt Metin</label>
                          <input type="text" value={formData?.descStandardTicket || ''} onChange={(e) => handleFormChange('descStandardTicket', e?.target?.value)} placeholder="Örn: Board olmadan etkinliğe katılım" className="w-full h-9 px-3 py-2 border border-input bg-background text-foreground rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-primary placeholder:text-muted-foreground" />
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>

              <div className="grid grid-cols-3 gap-4">
                <div>
                  <label className="block text-sm font-medium text-foreground mb-2">Can Yeleği Ücreti (TL)</label>
                  <Input
                    type="number"
                    value={formData?.priceLifeVest || 0}
                    onChange={(e) => handleFormChange('priceLifeVest', parseFloat(e?.target?.value) || 0)}
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-foreground mb-2">SUP Motoru Ücreti (TL)</label>
                  <Input
                    type="number"
                    value={formData?.priceSupMotor || 0}
                    onChange={(e) => handleFormChange('priceSupMotor', parseFloat(e?.target?.value) || 0)}
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-foreground mb-2">Su Geçirmez Çanta Ücreti (TL)</label>
                  <Input
                    type="number"
                    value={formData?.priceWaterproofBag || 0}
                    onChange={(e) => handleFormChange('priceWaterproofBag', parseFloat(e?.target?.value) || 0)}
                  />
                </div>
              </div>
              <div className="grid grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm font-medium text-foreground mb-2">Min Katılımcı</label>
                  <Input
                    type="number"
                    value={formData?.minParticipants}
                    onChange={(e) => handleFormChange('minParticipants', parseInt(e?.target?.value) || 1)}
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-foreground mb-2">Max Katılımcı</label>
                  <Input
                    type="number"
                    value={formData?.maxParticipants}
                    onChange={(e) => handleFormChange('maxParticipants', parseInt(e?.target?.value) || 0)}
                  />
                </div>
              </div>
              <div className="grid grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm font-medium text-foreground mb-2">Süre (Saat)</label>
                  <Input
                    type="number"
                    step="0.5"
                    min="0"
                    value={formData?.duration}
                    onChange={(e) => handleFormChange('duration', e?.target?.value === '' ? '' : parseFloat(e?.target?.value))}
                    placeholder="Örn: 2.5"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-foreground mb-2">Etkinlik Tipi</label>
                  <select
                    value={formData?.eventType}
                    onChange={(e) => handleFormChange('eventType', e?.target?.value)}
                    className="w-full h-10 px-3 py-2 border border-input bg-white text-black rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-primary"
                  >
                    <option value="sup">SUP</option>
                    <option value="surf">Surf</option>
                    <option value="windsurf">Windsurf</option>
                    <option value="kayak">Kayak</option>
                    <option value="kitesurf">Kitesurf</option>
                  </select>
                </div>
              </div>
              {/* Image Section - Multi Photo */}
              <div>
                <label className="block text-sm font-medium text-foreground mb-2">Etkinlik Fotoğrafları</label>

                {/* Existing / Added Photos Grid */}
                {photoList?.length > 0 && (
                  <div className="grid grid-cols-3 gap-2 mb-3">
                    {photoList?.map((photo, index) => (
                      <div key={index} className="relative group rounded-lg overflow-hidden border border-border">
                        <img
                          src={photo?.preview}
                          alt={`Fotoğraf ${index + 1}`}
                          className="w-full h-40 object-cover"
                          onError={(e) => { e.target.src = '/assets/images/no_image.png'; }}
                        />
                        {index === 0 && (
                          <span className="absolute top-1 left-1 bg-primary text-white text-xs px-1.5 py-0.5 rounded font-medium">
                            Ana
                          </span>
                        )}
                        <button
                          type="button"
                          onClick={() => handleRemovePhoto(index)}
                          className="absolute top-1 right-1 w-6 h-6 bg-error text-white rounded-full flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity"
                        >
                          <Icon name="X" size={12} />
                        </button>
                      </div>
                    ))}
                  </div>
                )}

                {/* Add Photo Tabs */}
                <div className="flex gap-2 mb-3">
                  <button
                    type="button"
                    onClick={() => setImageUploadMode('url')}
                    className={`flex-1 py-2 px-3 rounded-md text-sm font-medium border transition-colors ${imageUploadMode === 'url' ? 'bg-primary text-white border-primary' : 'bg-white text-foreground border-border hover:bg-muted'}`}
                  >
                    <span className="flex items-center justify-center gap-2">
                      <Icon name="Link" size={14} />
                      URL ile Ekle
                    </span>
                  </button>
                  <button
                    type="button"
                    onClick={() => setImageUploadMode('file')}
                    className={`flex-1 py-2 px-3 rounded-md text-sm font-medium border transition-colors ${imageUploadMode === 'file' ? 'bg-primary text-white border-primary' : 'bg-white text-foreground border-border hover:bg-muted'}`}
                  >
                    <span className="flex items-center justify-center gap-2">
                      <Icon name="Upload" size={14} />
                      Dosya Yükle
                    </span>
                  </button>
                </div>

                {imageUploadMode === 'url' ? (
                  <div className="flex gap-2">
                    <Input
                      type="text"
                      value={newPhotoUrl}
                      onChange={(e) => setNewPhotoUrl(e?.target?.value)}
                      placeholder="https://... görsel URL'si"
                      onKeyDown={(e) => { if (e?.key === 'Enter') { e?.preventDefault(); handleAddPhotoUrl(); } }}
                    />
                    <button
                      type="button"
                      onClick={handleAddPhotoUrl}
                      disabled={!newPhotoUrl?.trim()}
                      className="px-4 py-2 bg-primary text-white rounded-lg text-sm font-medium hover:bg-primary/90 disabled:opacity-50 disabled:cursor-not-allowed transition-colors flex-shrink-0"
                    >
                      Ekle
                    </button>
                  </div>
                ) : (
                  <div
                    className="border-2 border-dashed border-border rounded-lg p-6 text-center cursor-pointer hover:border-primary transition-colors"
                    onClick={() => multiFileInputRef?.current?.click()}
                  >
                    <input
                      ref={multiFileInputRef}
                      type="file"
                      accept="image/*"
                      multiple
                      onChange={handleMultiFileSelect}
                      className="hidden"
                    />
                    <Icon name="ImagePlus" size={32} className="mx-auto mb-2 text-muted-foreground" />
                    <p className="text-sm text-muted-foreground">Fotoğraf seçmek için tıklayın</p>
                    <p className="text-xs text-muted-foreground mt-1">Birden fazla fotoğraf seçebilirsiniz • JPG, PNG, WEBP</p>
                  </div>
                )}

                {photoList?.length === 0 && (
                  <p className="text-xs text-muted-foreground mt-2">Henüz fotoğraf eklenmedi. İlk eklenen fotoğraf ana görsel olarak kullanılır.</p>
                )}
              </div>

              {/* Publish Status Toggle */}
              <div className="bg-muted/30 border border-border rounded-lg p-4">
                <div className="flex items-center justify-between">
                  <div>
                    <p className="text-sm font-medium text-foreground">Yayın Durumu</p>
                    <p className="text-xs text-muted-foreground mt-0.5">
                      {formData?.status === 'published' ? 'Etkinlik yayında ve herkese görünür' : 'Etkinlik taslak olarak kaydedilecek'}
                    </p>
                  </div>
                  <button
                    type="button"
                    onClick={() => handleFormChange('status', formData?.status === 'published' ? 'draft' : 'published')}
                    className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors focus:outline-none ${formData?.status === 'published' ? 'bg-success' : 'bg-muted-foreground/30'}`}
                  >
                    <span
                      className={`inline-block h-4 w-4 transform rounded-full bg-white shadow transition-transform ${formData?.status === 'published' ? 'translate-x-6' : 'translate-x-1'}`}
                    />
                  </button>
                </div>
                {formData?.status === 'published' && (
                  <div className="mt-2 flex items-center gap-1.5 text-xs text-success">
                    <Icon name="CheckCircle" size={12} />
                    <span>Yayınla — etkinlik canlıya alınacak</span>
                  </div>
                )}
              </div>

              {/* Custom Options Section */}
              {formData?.customOptions?.length > 0 && (
                <div className="bg-muted/20 border border-border rounded-lg p-4">
                  <p className="text-sm font-medium text-foreground mb-3">Ekstra Seçenekler</p>

                  {/* Selection Type Toggle */}
                  <div className="mb-3 p-3 bg-muted/40 rounded-lg border border-border">
                    <label className="block text-xs font-medium text-foreground mb-2">Seçim Tipi</label>
                    <div className="flex flex-col sm:flex-row gap-2">
                      <label
                        className="flex items-center gap-2 cursor-pointer flex-1 p-2 rounded-lg border-2 transition-colors duration-200"
                        style={{
                          borderColor: formData?.customOptionsType === 'single' ? 'var(--primary)' : 'var(--border)',
                          background: formData?.customOptionsType === 'single' ? 'color-mix(in srgb, var(--primary) 10%, transparent)' : 'transparent'
                        }}
                      >
                        <input
                          type="radio"
                          name="editCustomOptionsType"
                          value="single"
                          checked={formData?.customOptionsType === 'single'}
                          onChange={() => handleFormChange('customOptionsType', 'single')}
                          className="w-4 h-4 text-primary border-border focus:ring-primary cursor-pointer"
                        />
                        <div>
                          <span className="text-xs font-semibold text-foreground block">Tekli Seçim (Radio)</span>
                          <span className="text-xs text-muted-foreground">Kullanıcı sadece birini seçebilir</span>
                        </div>
                      </label>
                      <label
                        className="flex items-center gap-2 cursor-pointer flex-1 p-2 rounded-lg border-2 transition-colors duration-200"
                        style={{
                          borderColor: formData?.customOptionsType === 'multiple' ? 'var(--primary)' : 'var(--border)',
                          background: formData?.customOptionsType === 'multiple' ? 'color-mix(in srgb, var(--primary) 10%, transparent)' : 'transparent'
                        }}
                      >
                        <input
                          type="radio"
                          name="editCustomOptionsType"
                          value="multiple"
                          checked={formData?.customOptionsType === 'multiple'}
                          onChange={() => handleFormChange('customOptionsType', 'multiple')}
                          className="w-4 h-4 text-primary border-border focus:ring-primary cursor-pointer"
                        />
                        <div>
                          <span className="text-xs font-semibold text-foreground block">Çoklu Seçim (Checkbox)</span>
                          <span className="text-xs text-muted-foreground">Kullanıcı birden fazla seçebilir</span>
                        </div>
                      </label>
                    </div>
                  </div>

                  <div className="space-y-2">
                    {formData?.customOptions?.map((opt, idx) => (
                      <div key={idx} className="flex items-center gap-2">
                        <Input
                          type="text"
                          value={opt?.title || ''}
                          onChange={(e) => {
                            const updated = [...formData?.customOptions];
                            updated[idx] = { ...updated?.[idx], title: e?.target?.value };
                            handleFormChange('customOptions', updated);
                          }}
                          placeholder="Açıklama (Örn: VIP Transfer)"
                          className="flex-1"
                        />
                        <Input
                          type="number"
                          value={opt?.price || 0}
                          onChange={(e) => {
                            const updated = [...formData?.customOptions];
                            updated[idx] = { ...updated?.[idx], price: parseFloat(e?.target?.value) || 0 };
                            handleFormChange('customOptions', updated);
                          }}
                          placeholder="Fiyat (TL)"
                          className="w-28"
                        />
                        <button
                          type="button"
                          onClick={() => {
                            const updated = formData?.customOptions?.filter((_, i) => i !== idx);
                            handleFormChange('customOptions', updated);
                          }}
                          className="w-8 h-8 flex items-center justify-center text-error hover:bg-error/10 rounded-md transition-colors flex-shrink-0"
                        >
                          <Icon name="Trash2" size={14} />
                        </button>
                      </div>
                    ))}
                  </div>
                </div>
              )}
              <button
                type="button"
                onClick={() => handleFormChange('customOptions', [...(formData?.customOptions || []), { title: '', price: 0 }])}
                className="w-full py-2 px-3 border border-dashed border-border rounded-lg text-sm text-muted-foreground hover:border-primary hover:text-primary transition-colors flex items-center justify-center gap-2"
              >
                <Icon name="Plus" size={14} />
                Yeni Ekstra Seçenek Ekle
              </button>

              <div className="flex gap-3 pt-4">
                <Button
                  variant="outline"
                  onClick={handleCloseModal}
                  className="flex-1"
                >
                  İptal
                </Button>
                <Button
                  variant="default"
                  onClick={handleSaveEvent}
                  className="flex-1"
                  disabled={isLoading || isUploadingImage}
                >
                  {isUploadingImage ? 'Fotoğraflar yükleniyor...' : isLoading ? 'Kaydediliyor...' : 'Kaydet'}
                </Button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default DetailedEventManagement;